/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'
import qs from 'qs'

import Auth from './Auth'

import config from '../config'

class Ticket {
  @observable
  tickets = {
    all: [],
    search: []
  }

  @observable responses = {}

  @action
  getTicket = tId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/ticket/${tId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const index = this.tickets.all.slice().findIndex(t => t.id === tId)

        this.tickets = {
          ...this.tickets,
          all: [
            ...(index > -1
              ? [
                  ...this.tickets.all.slice(0, index),
                  res.data.data,
                  ...this.tickets.all.slice(index + 1)
                ]
              : [...this.tickets.all.slice(), res.data.data])
          ]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getMyTickets = () => {
    const _query = qs.stringify({
      type: 'ticket',
      q: `userId:${Auth.token.userId}`,
      sortKey: 'updatedAt',
      sortType: 'desc'
    })

    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?${_query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.tickets = {
          ...this.tickets,
          all: [
            ...res.data.hits.hits.reduce((arr, p) => [...arr, p._source], [])
          ]
        }

        return this.tickets.all.slice()
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getAllTickets = () => {
    const _query = qs.stringify({
      type: 'ticket',
      q: `*`,
      sortKey: 'updatedAt',
      sortType: 'desc'
    })

    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?${_query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.tickets = {
          ...this.tickets,
          all: [
            ...this.tickets.all,
            ...res.data.hits.hits.reduce(
              (arr, p) => [
                ...arr,
                ...(!this.tickets.all.find(t => t.id === p._source.id)
                  ? [p._source]
                  : [])
              ],
              []
            )
          ]
        }

        return this.tickets.all.slice()
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getCommunityTickets = comIdList => {
    const _query = qs.stringify({
      type: 'ticket',
      q: `*`,
      sortKey: 'updatedAt',
      sortType: 'desc',
      comId: comIdList.join('|')
    })

    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?${_query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.tickets = {
          ...this.tickets,
          all: [
            ...this.tickets.all.slice(),
            ...res.data.hits.hits.reduce(
              (arr, p) => [
                ...arr,
                ...(!this.tickets.all.find(t => t.id === p._source.id)
                  ? [p._source]
                  : [])
              ],
              []
            )
          ]
        }

        return this.tickets.all.slice()
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postTicket = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/ticket/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        title: data.title,
        content: data.content,
        category: data.category,
        priority: data.priority,
        ...(data.comId ? { comId: data.comId } : {})
      }
    })
      .then(res => {
        this.tickets = {
          ...this.tickets,
          all: [...this.tickets.all.slice(), res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchTicket = (tId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/ticket/${tId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(() => {
        const index = this.tickets.all.slice().findIndex(t => t.id === tId)

        this.tickets = {
          ...this.tickets,
          all: [
            ...(index > -1
              ? [
                  ...this.tickets.all.slice(0, index),
                  { ...this.tickets.all.slice()[index], [field]: value },
                  ...this.tickets.all.slice(index + 1)
                ]
              : [...this.tickets.all.slice()])
          ]
        }
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getResponses = tId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/ticket/${tId}/response`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.responses = {
          ...this.responses,
          [tId]: [...res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postResponse = (tId, content) => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/ticket/${tId}/response`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        content
      }
    })
      .then(res => {
        this.responses = {
          ...this.responses,
          [tId]: [...this.responses[tId], res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  insertLocalTicket(data) {
    const index = this.tickets.all.slice().findIndex(t => t.id === data.id)
    console.log('insert', index, data.id)

    this.tickets = {
      ...this.tickets,
      all: [
        ...(index > -1
          ? [
              ...this.tickets.all.slice(0, index),
              data,
              ...this.tickets.all.slice(index + 1)
            ]
          : [...this.tickets.all.slice(), data])
      ]
    }
  }

  @action
  updateLocalTicket(data) {
    const ticket = data.ticket
    const index = this.tickets.all.slice().findIndex(t => t.id === ticket.id)
    console.log('updating', index, ticket)
    this.tickets = {
      ...this.tickets,
      all: [
        ...(index > -1
          ? [
              ...this.tickets.all.slice(0, index),
              ticket,
              ...this.tickets.all.slice(index + 1)
            ]
          : [...this.tickets.all.slice(), ticket])
      ]
    }
  }

  @action
  insertLocalResponse(data) {
    const index = this.responses[data.ticketId]
      .slice()
      .findIndex(t => t.id === data.id)

    this.responses = {
      ...this.responses,
      [data.ticketId]: [
        ...(index > -1
          ? [
              ...this.responses[data.ticketId].slice(0, index),
              data,
              ...this.responses[data.ticketId].slice(index + 1)
            ]
          : [...this.responses[data.ticketId].slice(), data])
      ]
    }
  }

  @action
  updateLocalResponse(data) {
    const index = this.responses[data.ticketId]
      .slice()
      .findIndex(t => t.id === data.id)

    this.responses = {
      ...this.responses,
      [data.ticketId]: [
        ...(index > -1
          ? [
              ...this.responses[data.ticketId].slice(0, index),
              data,
              ...this.responses[data.ticketId].slice(index + 1)
            ]
          : [...this.responses[data.ticketId].slice(), data])
      ]
    }
  }

  // contact form
  @action
  postContactForm = data => {
    const values = Object.keys(data).reduce((arr, key) => {
      return [
        ...arr,
        ...(typeof data[key] === 'string'
          ? [data[key]]
          : Object.keys(data[key]).map(_key => data[key][_key]))
      ]
    }, [])

    if (!values.every(item => item.length > 0)) {
      this.responses = {
        ...this.responses,
        contact: {
          statusCode: 400,
          data: {
            message: 'All fields are required'
          }
        }
      }

      return Promise.reject()
    }

    return axios({
      method: 'post',
      url: `${config.api_uri}/ticket/contact/`,
      data: {
        fullName: data.fullName,
        email: data.email,
        title: data.title,
        content: data.content
      }
    })
      .then(res => {
        this.responses = {
          ...this.responses,
          contact: {
            statusCode: res.status,
            data: {
              ...res.data,
              ...(!res.data.message
                ? { message: 'Success! Your message has been sent!' }
                : {})
            }
          }
        }

        return this.responses.contact
      })
      .catch(e => {
        console.log(e)
        this.responses = {
          ...this.responses,
          contact: {
            statusCode: e.response.status,
            data: {
              ...e.response.data,
              ...{
                ...(+e.response.status === 500
                  ? { message: 'Internal server error. Try again later.' }
                  : { message: e.response.data.message })
              }
            }
          }
        }

        return this.responses.contact
      })
  }
}

export default new Ticket()



// WEBPACK FOOTER //
// ./src/stores/Ticket.js